import { api } from './api';

// Pulls a blob from the API (with auth + params) and triggers a browser save
// dialog. Shared by the operations pages and the handoff calendar.
function saveBlob(data: BlobPart, mime: string, filename: string): void {
  const blob = new Blob([data], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}

export async function downloadBlob(
  endpoint: string,
  params: Record<string, string>,
  mime: string,
  filename: string,
): Promise<void> {
  const res = await api.get(endpoint, { params, responseType: 'blob' });
  saveBlob(res.data, mime, filename);
}

// POST variant — for endpoints that MUTATE while producing the file (e.g. the
// delivery-documents batch, which issues Invoice #2 / delivery notes then prints).
export async function downloadBlobPost(
  endpoint: string,
  params: Record<string, string>,
  mime: string,
  filename: string,
  body?: unknown,
): Promise<void> {
  const res = await api.post(endpoint, body ?? {}, { params, responseType: 'blob' });
  saveBlob(res.data, mime, filename);
}

export const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const PDF_MIME = 'application/pdf';
export const ZIP_MIME = 'application/zip';
export const CSV_MIME = 'text/csv';
